<ng-container *ngFor="let tab of tabs">
    <div class="menu-item"
         [routerLink]="tab.url"
         [class._active]="tab.isSelected"
         [captureId]="tab.key">
        {{tabsLabelPrefix + '.' + tab.key | translate}}
    </div>
</ng-container>
